<template>
	<div class="banner_top" :style="scrollTop > 67?'background:#fff;position: sticky;':''">
	
		<div class="header">
			<div class="logo_box">
				<div class="logo">
					<img src="../../../public/images/logo.png" >
				</div>
				<div class="qw_logo">
					<img src="../../../public/images/qwlogo.png" >
				</div>
			</div>
			<div class="header_list">
				<ul>
					<li :class="listIndex == index?'li2':''" v-for="(item,index) in list" :key='index' @click="go(item.url,index)">
						{{item.title}}
					</li>
				</ul>
			</div>
			<div class="header_rig">
				<div class="btn " @click="change()">预约演示</div>
				<!-- <div class="btn btn2" @click="change()">登录/注册</div> -->
			</div>
			<div :class="!show?'open':'close' " @click="showPopup">
				
			</div>
		</div>
		<!-- 移动端显示 -->
		<van-popup v-model="show" class="popup" position="right" :overlay="overlay">
			<ul>
				<li v-for="(item,index) in list" :key='index' @click="go(item.url,index)">
					<span :class="listIndex == index?'span2':''">{{item.title}}</span>
				</li>
			</ul>
			<div class="btns">
				<div class="btn " @click="change()">预约演示</div>
				<!-- <div class="btn btn2" >登录/注册</div> -->
			</div>
		</van-popup>
		<register v-show="registerShow" @change='change' @add='add'></register>
	</div>
</template>

<script>
	import register from "@/components/register/index.vue"
	import { addClue } from '@/api'
	export default {
		components:{
			register
		},
		data() {
			return{
				list:[{
					title:'首页',
					url:'/home',
				},{
					title:'产品服务',
					url:'/product',
				},{
					title:'渠道合作',
					url:'/channel',
				},{
					title:'关于我们',
					url:'/aboutUs',
				}],
				listIndex:'0',
				scrollTop:'',
				show: false,
				overlay:false,
				registerShow:false,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.windowScroll) //监听页面滚动
		},
		watch:{
			$route:{
				handler(n,o){
					if(n.fullPath == '/product'){
						this.listIndex = 1
					}
					if(n.fullPath == '/home'){
						this.listIndex = 0
					}
					if(n.fullPath == '/channel'){
						this.listIndex = 2
					}
					if(n.fullPath == '/aboutUs'){
						this.listIndex = 3
					}
				},
				immediate: true,
				deep: true
			}
		},
		methods:{
			add(data){
				addClue(data).then(res => {
					if(res.code == 200){
						this.$toast('操作成功');
						console.log(res)
						this.registerShow = false
					}else{
						this.$toast(res.msg);
					}
				})
			},
			// 是否打开注册弹框
			change(){
				console.log('2323')
				this.registerShow = !this.registerShow
			},
			// 跳转
			go(url,index){
				document.documentElement.scrollTop = 0
				this.listIndex = index
				this.show = false
				this.$router.push(url)
			},
			// 弹出层
			showPopup() {
				this.show = !this.show;
			},
			// 获取滚动条高度
			windowScroll() {
				let scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop
				// console.log(scrollTop)
				this.scrollTop = scrollTop
				// return scrollTop
			}
		}
	}
</script>

<style lang="scss" scoped>
	.banner_top{
		width: 100%;
		height: 0.8rem;
		position: absolute;
		display: flex;
		justify-content: center;
		// margin-top: 0.21rem;
		z-index: 11;
		position: -webkit-sticky;
		// position: sticky;
		// background-color: #fff;
		top: 0px;
		.header{
			width: 12rem;
			display: flex;
			align-items: center;
		}
		.logo_box{
			width: 23.41%;
			height: 0.39rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 0.16rem;
			
			.logo{
				width:200px;
				height: 34px;
				margin-top: -10px;
				img{
					width: 100%;
				}
				
			}
			.qw_logo{
				width: 140px;
				height: 30px;
				margin-left: 20px;
				margin-top: 10px;
				img{
					width: 100%;
				}
				// background: url(../../../public/images/qwlogo.png) no-repeat center center;
				// background-size: 1.21rem 0.25rem;
			}
		}
		.header_list{
			width: 37%;
			// margin-top: 0.12rem;
			margin-left:6.82%;
			ul{
				width: 100%;
				height: 0.16rem;
				display: flex;
				justify-content: space-between;
				li{
					height: 0.16rem;
					font-size: 0.16rem;
					
				}
				li:hover{
					color: #FF7300;
				}
				.li2{
					color: #FF7300;
				}
			}
			
		}
		.header_rig{
			width: 2rem;
			height: 0.3rem;
			margin-top: 0.04rem;
			margin-left: 7.45%;
			// display: flex;
			// justify-content: space-between;
			
			.btn{
				width: 0.9rem;
				height: 0.3rem;
				border: 0.01rem solid #FF9729;
				border-radius: 0.1rem;
				font-size: 0.12rem;
				text-align: center;
				line-height: 0.3rem;
				float: right;
			}
			
		}
		.open{
			display: none;
		}
		.btn2{
			background: #FF9729;
			border-radius: 0.1rem;
			color: #fff;
		}
	}
	
	@media (max-width:1026px){
		.banner_top{
			position: absolute;
			top: 0;
			width: 100%;
			height: 1rem;
			display: flex;
			margin-top: 0rem;
			background-color: #fff;
			position: -webkit-sticky;
			position: sticky;
			
			
			.header{
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				background: #fff;
				box-shadow: -9px 0px 8px 0px rgba(0, 0, 0, 0.04);
			}
			
			.logo_box{
				width: 1.96rem;
				height: 0.68rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 0.16rem;
				margin-top: 0.16rem;
				margin-left: 0.28rem;
				
				.logo{
					width: 1.96rem;
					height: 0.68rem;
					background: url(../../../public/images/phoneLogo.png) no-repeat center center;
					background-size: 1.96rem 0.68rem;
					
				}
				.qw_logo{
					width: 44%;
					height: 0.25rem;
					background: url(../../../public/images/qwlogo.png) no-repeat center center;
					background-size: 1.21rem 0.25rem;
					display: none;
				}
			}
			
			.header_list{
				width: 37%;
				// margin-top: 0.12rem;
				margin-left:6.82%;
				display: none;
				
				ul{
					width: 100%;
					height: 0.16rem;
					display: flex;
					justify-content: space-between;
					li{
						height: 0.16rem;
						font-size: 0.16rem;
					}
				}
			}
			.header_rig{
				width: 2rem;
				height: 0.3rem;
				margin-top: 0.04rem;
				margin-left: 7.45%;
				display: flex;
				justify-content: space-between;
				display: none;
				
				.btn{
					width: 0.9rem;
					height: 0.3rem;
					border: 0.01rem solid #FF9729;
					border-radius: 0.1rem;
					font-size: 0.12rem;
					text-align: center;
					line-height: 0.3rem;
				}
			}
			.open{
				width: 0.45rem;
				height: 0.36rem;
				display: block;
				margin-right: 0.3rem;
				background:url(../../../public/images/menu.png)no-repeat center center;
				background-size: 0.45rem 0.36rem;
			}
			.close{
				width: 0.47rem;
				height: 0.46rem;
				display: block;
				margin-right: 0.3rem;
				background:url(../../../public/images/close.png)no-repeat center center;
				background-size: 0.47rem 0.46rem;
			}
		}
		.popup{
			width: 3.5rem;
			height: 100%;
			box-shadow: -9px 0px 8px 0px rgba(0, 0, 0, 0.04);
			z-index: -1 !important;
			ul{
				margin-top: 1.58rem;
				li{
					
					font-size: 0.3rem;
					color: #000000;
					margin-left: 0.59rem;
					margin-bottom: 0.79rem;
					
					span{
						padding: 0.11rem 0;
						// border-bottom: 0.04rem solid #FF9729;
					}
					.span2{
						padding: 0.11rem 0;
						border-bottom: 0.04rem solid #FF9729;
					}
				}
			}
			.btns{
				margin-left: 0.62rem;
				margin-top: 0.16rem;
				.btn{
					width: 1.8rem;
					height: 0.5rem;
					border: 0.02rem solid #FF9729;
					border-radius: 0.1rem;
					font-size: 0.26rem;
					color: #FF9729;
					text-align: center;
					line-height: 0.5rem;
					margin-bottom: 0.65rem;
					
				}
				.btn2{
					background: #FF9729;
					border-radius: 0.1rem;
					color: #fff;
				}
			}
		}
	}
</style>
